import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import Layout from './Layout';
import { requestCurrentUser } from '../actions/users';
import { logout, requestLogin } from '../actions/authentication';
import { currentUserSelector } from '../selectors/currentUserSelector';
import { requestAccountList } from '../actions/accountManager';
import { requestBrandsList } from '../actions/brandsList';
import { Box, CircularProgress } from '@material-ui/core';

const App = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(currentUserSelector);
  const base_url = process.env.REACT_APP_SUBSCRIBER_API
  // const base_url = 'localhost:8000'
  const isLoadingBrandsList = useSelector(state => state?.brandsList?.isLoading);
  const isLoadingAccountsList = useSelector(state => state?.socialAccount?.isLoading);
  const isLoading = isLoadingBrandsList || isLoadingAccountsList;

  useEffect(() => {
    const { hostname } = window.location;
    const subDomain = hostname.split('.').reverse()[2];
    // const subDomain = 'brandcil'
    if (subDomain === "www") {
      return window.location.href = "https://brandcil.com";
    }
    if (subDomain === null) {
      return
    }

    fetch(`https://${subDomain}.${base_url}`)
      .then((data) => data.json())
      .then((response) => {
        if (response && response.status_code && response.status_code === 200) {
          return dispatch(requestCurrentUser()).then(async () => {
            dispatch(requestAccountList());
            dispatch(requestBrandsList());
          }).catch(() => {
            // console.log("current user State inside catch");
            dispatch(logout());
          });
        }
        // return window.location.replace('http://www.remotewebteam.com/');
      }).catch(err => {
        // console.log("inside catch of main promis");
        // removeToken('region');
        //window.location.reload(false);
        dispatch(logout());
      })
    // return window.location.replace('http://www.remotewebteam.com/');
  }, []);
  // console.log("current user data",currentUser)

  if (isLoading || isEmpty(currentUser)) {
    return (
      <Box style={{ position: 'absolute', top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
        <CircularProgress />
      </Box>
    )
  }
  return <Layout />
}

export default App;
